<template>
  <expandable header="Previous Illnesses" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.thyroid_status"
          label="Thyroid Status"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.long_term_medications"
          label="Long Term Medications"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-500"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.previous_surgeries"
          label="Previous Surgeries"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-500"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
export default {
  components: { Expandable },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
